import colors from 'styles/colors'
import { typography } from 'styles/typography'

export const defaultStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    padding: '22px 18px 15px 18px',
    borderLeft: `1px solid ${colors.pixelWhite}`,
    backgroundColor: colors.white
  },
  containerBorderTop: {
    borderLeft: 0,
    borderTop: `1px solid ${colors.pixelWhite}`
  },
  buttonBook: (isMobile = false) => {
    return {
      button: {
        fontSize: 14,
        marginBottom: isMobile ? 7 : 0
      }
    }
  },
  buttonCall: (isMobile = false) => {
    return {
      button: {
        fontSize: 14,
        backgroundColor: colors.secondary,
        marginBottom: isMobile ? 7 : 0
      }
    }
  },
  link: {
    ...typography.fontMedium,
    fontSize: 16,
    lineHeight: '17px',
    textAlign: 'center',
    cursor: 'pointer',
    color: colors.primary
  }
}
